import Meta from 'src/components/meta/Meta';

const SmartInvestMeta = () => <Meta
  title="Smart Invest | BrickX"
  description="With Smart Invest from BrickX, make a monthly deposit and watch your property portfolio grow."
/>;

export default SmartInvestMeta;
